var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHand = function SvgHand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.08 18.72v-7.45c0-.7.57-1.27 1.27-1.27s1.27.57 1.27 1.27v7.45M21.62 18.72v-6.75c0-.7.57-1.27 1.27-1.27.7 0 1.27.57 1.27 1.27h0v6.75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.17 18.72v-4.39c0-.7.57-1.27 1.27-1.27.7 0 1.27.57 1.27 1.27h0V24.4c0 1.11-.36 2.2-1.02 3.09l-.42.57c-.04.06-.07.13-.07.2v1.14c0 .33-.27.6-.6.6h-6.86c-.33 0-.6-.27-.6-.6h0v-1.23c0-.11-.05-.21-.13-.27l-.53-.4a5.222 5.222 0 0 1-1.9-2.93l-1.25-5.27c-.16-.68.26-1.37.95-1.53 0 0 0 0 0 0h.03c.67-.16 1.34.24 1.51.9l.71 2.64v-8.68c0-.7.57-1.27 1.27-1.27.7 0 1.27.57 1.27 1.27h0v6.1"
  })));
};
export default SvgHand;